import MTextInput from './MTextInput.vue';

MTextInput.install = (app) => {
  app.component('MTextInput', MTextInput);
};

export { MTextInput };
